// utils/formatAmount.js

export const formatAmount = (amount) => {
    const num = Number(amount || 0);

    return Number.isInteger(num)
        ? num.toString()
        : num.toFixed(2);
};